/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Close_LabelInputs */

const en_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_audio_recorder_close_label = /** @type {(inputs: Audio_Recorder_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Audio_Recorder_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_close_label = /** @type {((inputs?: Audio_Recorder_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_close_label(inputs)
	if (locale === "de") return de_audio_recorder_close_label(inputs)
	if (locale === "it") return it_audio_recorder_close_label(inputs)
	if (locale === "ru") return ru_audio_recorder_close_label(inputs)
	if (locale === "es") return es_audio_recorder_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_close_label(inputs)
	if (locale === "ja") return ja_audio_recorder_close_label(inputs)
	if (locale === "hi") return hi_audio_recorder_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_close_label(inputs)
	return en_audio_recorder_close_label(inputs)
});